import BaseCardHandler from './BaseCardHandler';
import CardSystem from '../CardSystem';
import { ICardsState } from '../../../State/Card/ICardState';
import Interactable from 'Component/Interactable';

export default class CanisterPreBoosterCardHandler extends BaseCardHandler {
    public handleCardFolded(state: ICardsState, cardSystem: CardSystem) {
        if (!cardSystem.stackContainer.hasChild(this.card)) {
            cardSystem.stackContainer.addChild(this.card);
        }

        this.transform.position.set(0, -200);
        this.transform.rotation = 0.3;
        this.card.getComponent(Interactable).buttonMode = false;
    }
}
